import { apiClient } from './apiClient';

/**
 * Get current user's shopping cart items
 */
export const getShoppingCart = async () => {
  try {
    const response = await apiClient.get('/api/v1/cart');
    return response.data.data || [];
  } catch (error) {
    console.error('Failed to fetch shopping cart:', error);
    return [];
  }
};

/**
 * Add item to shopping cart
 */
export const addToCart = async (product) => {
  try {
    const response = await apiClient.post('/api/v1/cart/add', product);
    return response.data.data;
  } catch (error) {
    console.error('Failed to add item to cart:', error);
    throw error;
  }
};

/**
 * Remove item from shopping cart
 */
export const removeFromCart = async (productUid) => {
  try {
    const response = await apiClient.delete(`/api/v1/cart/${productUid}`);
    return response.data;
  } catch (error) {
    console.error('Failed to remove item from cart:', error);
    throw error;
  }
};

/**
 * Clear entire shopping cart
 */
export const clearShoppingCart = async () => {
  try {
    const response = await apiClient.post('/api/v1/cart/clear');
    return response.data;
  } catch (error) {
    console.error('Failed to clear cart:', error);
    throw error;
  }
};

/**
 * Get all user's collections
 */
export const getUserCollections = async () => {
  try {
    const response = await apiClient.get('/api/v1/collections');
    return response.data.data || [];
  } catch (error) {
    console.error('Failed to fetch collections:', error);
    return [];
  }
};

/**
 * Get specific collection with products
 */
export const getCollection = async (collectionId) => {
  try {
    const response = await apiClient.get(`/api/v1/collections/${collectionId}`);
    return response.data.data;
  } catch (error) {
    console.error('Failed to fetch collection:', error);
    throw error;
  }
};

/**
 * Create a new collection from cart items
 */
export const createCollection = async (name, remark, products) => {
  try {
    const response = await apiClient.post('/api/v1/collections', {
      name,
      remark,
      products
    });
    return response.data.data;
  } catch (error) {
    console.error('Failed to create collection:', error);
    throw error;
  }
};

/**
 * Update existing collection (add products)
 */
export const updateCollection = async (collectionId, products) => {
  try {
    const response = await apiClient.post(`/api/v1/collections/${collectionId}`, {
      products
    });
    return response.data.data;
  } catch (error) {
    console.error('Failed to update collection:', error);
    throw error;
  }
};
